import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAuthorityClaimMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  set: Types.Authority_Claims_Set_Input;
}>;


export type UpdateAuthorityClaimMutation = { __typename?: 'mutation_root', update_authority_claims_by_pk?: { __typename?: 'authority_claims', id: any } | null };


export const UpdateAuthorityClaimDocument = gql`
    mutation UpdateAuthorityClaim($id: uuid!, $set: authority_claims_set_input!) {
  update_authority_claims_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdateAuthorityClaimMutationFn = Apollo.MutationFunction<UpdateAuthorityClaimMutation, UpdateAuthorityClaimMutationVariables>;

/**
 * __useUpdateAuthorityClaimMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorityClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorityClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorityClaimMutation, { data, loading, error }] = useUpdateAuthorityClaimMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateAuthorityClaimMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuthorityClaimMutation, UpdateAuthorityClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuthorityClaimMutation, UpdateAuthorityClaimMutationVariables>(UpdateAuthorityClaimDocument, options);
      }
export type UpdateAuthorityClaimMutationHookResult = ReturnType<typeof useUpdateAuthorityClaimMutation>;
export type UpdateAuthorityClaimMutationResult = Apollo.MutationResult<UpdateAuthorityClaimMutation>;
export type UpdateAuthorityClaimMutationOptions = Apollo.BaseMutationOptions<UpdateAuthorityClaimMutation, UpdateAuthorityClaimMutationVariables>;